import React from "react";
import { Form, FormCheckProps } from "react-bootstrap";

interface IRadioPaymentProps extends FormCheckProps {
  children: React.ReactNode;
  isLargeTranslation?: boolean;
}

export default function RadioPayment({
  children,
  isLargeTranslation,
  ...props
}: IRadioPaymentProps) {
  return (
    <>
      <Form.Label
        className={`rounded border p-3 w-100 d-flex ${isLargeTranslation ? "gap-3" : "gap-2 align-items-center"} h-100`}
      >
        <Form.Check type="radio" {...props} />
        {children}
      </Form.Label>
    </>
  );
}
